// extracted by mini-css-extract-plugin
export default {"supplierLine":"MaterialsCommerceSupplierCta_supplierLine__PBz1t","supplierLink":"MaterialsCommerceSupplierCta_supplierLink__mp-GW"};